import { useCallback, useState, useMemo } from "react";

import { useEventListener } from "../../../../hooks";
import { RectPos } from "../../../Utility/Dropdown/Dropdown.interface";
import { getDefaultScrollConfig } from "../../../../helpers";

interface IUseSetFixed {
  menuHeight?: number;
  menuOffset?: number;
  isMobile?: boolean;
}

const listenerConfig = getDefaultScrollConfig();

const useSetFixed = ({
  menuHeight = 0,
  menuOffset = 0,
  isMobile = false,
}: IUseSetFixed): { hasFixedPosition: boolean; fixedPositions: RectPos } => {
  const [hasFixedPosition, setFixedPosition] = useState(isMobile);

  const onScroll = useCallback(() => {
    if (!isMobile) {
      // calculate fixed position only for desktop views
      setFixedPosition(globalThis.scrollY >= menuOffset);
    }
  }, [menuOffset, isMobile]);

  const fixedPositions = useMemo(() => {
    return hasFixedPosition
      ? {
          top: `${menuHeight}px`,
        }
      : {};
  }, [hasFixedPosition, menuHeight]);

  useEventListener(`scroll`, onScroll, listenerConfig);

  return {
    hasFixedPosition,
    fixedPositions,
  };
};

export default useSetFixed;
